import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { CashCollections } from 'src/features/cashCollections/types/cashCollections';

const RESOURCE = '/parkings/:parkingId/cash-collections/:id/';

type QueryFnType = typeof queryFn;

interface DTO {
    id: string;
    parkingId: string;
}

const queryFn = ({ id, parkingId, ...params }: DTO): Promise<CashCollections> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, id }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });
};

export { useQueryHook as useGetParkingCashCollection };
